import {
  ActionReducerMap,
  MetaReducer
} from '@ngrx/store';
export interface AppState {

}

export const reducers: ActionReducerMap<AppState> = {};

export const metaReducers: Array<MetaReducer<any, any>> = [];

